import { useLingui } from '@lingui/react/macro';

import { DesktopBrandFilter } from '@/components/SharedFilters/BrandFilter/DesktopBrandFilter';
import { useCurrentOrganization } from '@/services/auth';

import { useFilters } from '../FiltersState';

export const FiltersArticleBrand = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();
  const [organization] = useCurrentOrganization();

  const {
    articleBrands: { articleBrands, setArticleBrands },
  } = useFilters();

  return (
    <DesktopBrandFilter
      selectedBrands={articleBrands}
      setSelectedBrands={setArticleBrands}
      brandsQuery={{ organizationId: organization?.id, limit: 500, offset: 0 }}
      tag={tag}
      label={t({
        id: 'settings.organization.entities.agreements.filters.article_brand.label',
        message: 'Article brand',
      })}
      searchPlaceholder={t({
        id: 'settings.organization.entities.agreements.filters.article_brand.search',
        message: 'Search brands',
      })}
      tagMultipleSelectionLabel={(selectedBrandsNumber) =>
        i18n._({
          id: 'settings.organization.entities.agreements.filters.article_brand.multiple',
          message: '{selectedBrandsNumber} brands',
          values: { selectedBrandsNumber },
        })
      }
    />
  );
};
